import React from 'react';
import Routes from './Route_temp';
import useMaintenance from "./Utilities/useMaintenance";
import MaintenancePage from "./Utilities/MaintenancePage";
import './i18n';

import 'react-data-grid/lib/styles.css';

import './setupPdfWorker'; // ← This sets workerSrc early
import { LoadingView } from './components/Loading';

function App() {
    const maintenance = useMaintenance();

    if (maintenance === null) {
        return (
            <LoadingView containerHeight='100vh' imgHeight='40px' />
        );
    }

    if (maintenance) {
        return <MaintenancePage />;
    }

    return (
        <Routes />
    );
}

export default App;